import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';


@Injectable()
export class Password {

    constructor(private http: HttpClient) { }

    save(newPassword: string): Observable<any> {
        return this.http.post('api/account/change_password', newPassword, { responseType: 'text' });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password/password.service.ts